import React from "react";
import { Stack } from "@mui/material";
import { useLocation, useNavigate } from "react-router";
import { StyledButton } from "src/components/StyledButton";

type Props = {
  cities: string[];
  ctaClassName?: string;
};

export function SimpleForm({ ctaClassName }: Props) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Stack spacing={3}>
      <StyledButton
        variant="contained"
        onClick={() =>
          navigate({
            pathname: "/input_property",
            search: location.search,
          })
        }
        className={ctaClassName}
      >
        無料で価格を確認する
      </StyledButton>
    </Stack>
  );
}
